// Boundary to the Tether WDK worker. Main-thread code must call through
// `walletCall` only — never postMessage the worker directly, never import
// its internals. Comlink.wrap(worker) is the RPC transport (CLAUDE.md hard
// rule #3); walletCall(method, params) is kept as the call shape so the
// ~10 existing call sites in actions.js didn't need to change one-by-one.
import * as Comlink from 'comlink';
import TetherWorker from '../workers/tether.worker.js?worker';

const worker = new TetherWorker();
const wdk = Comlink.wrap(worker);

export function walletCall(method, params) {
  return wdk[method](params);
}
